import gql from "graphql-tag";
import className from "classnames/bind";
import { GoogleMapFragment } from "@graphqlTypes";
import { Container, SectionFooter, SectionHeader } from "@components";

import styles from "./GoogleMap.module.scss";
const cx = className.bind(styles);

export default function GoogleMap(props: GoogleMapFragment) {
  const { headline, subhead, includeFooter, footer, mapEmbedUrl } = props;
  const showHeader = Boolean(headline || subhead);
  if (!mapEmbedUrl) {
    console.warn("GoogleMap component is missing mapEmbedUrl");
    return null;
  }
  return (
    <section className={cx(["google-map"])}>
      <Container className={cx("container")}>
        {showHeader && <SectionHeader headline={headline} subhead={subhead} />}
        { mapEmbedUrl && (
          <iframe
            src={mapEmbedUrl}
            className={cx("google-map__map")}
            style={{ border: 0 }}
            allowFullScreen={false}
            loading="lazy"
            title={`Map - ${headline?.replace(/\*\*/g, '')}`}
          />
        )}
        {includeFooter && (
          <SectionFooter text={footer.text} ctas={footer.ctas} />
        )}
      </Container>
    </section>
  );
}

GoogleMap.fragments = {
  entry: gql`
    fragment GoogleMap on FlexiblePageContentContentGoogleMapLayout {
      headline
      subhead
      mapEmbedUrl
      includeFooter
      footer {
        text
        ctas {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  `,
};
